/* eslint-disable import/prefer-default-export */

export const getId = (themeInfo) => {
  return themeInfo.themeId
}

export const getIds = (themeInfoList) => {
  const idList = []
  themeInfoList.forEach((themeInfo) => {
    idList.push(getId(themeInfo))
  })
  return idList
}
